import type {UIElement} from "../../stem-core/ui/UIBase";
import type {NodeAttributes} from "../../stem-core/ui/NodeAttributes";
import {UI} from "../../stem-core/ui/UIBase";
import {StyleSheet} from "../../stem-core/ui/Style";
import {CloseIcon} from "../../core/ui/SVGElements.jsx";
import {Router} from "../../stem-core/ui/Router";
import {WidgetRoutes} from "./WidgetRoutes";
import {styleRule} from "../../stem-core/decorators/Style";
import {registerStyle} from "../../stem-core/ui/style/Theme";
import {collapseIframe} from "./misc/WidgetUtils";


export class WidgetCloseButtonStyle extends StyleSheet {
    @styleRule
    container = {
        position: "absolute",
        zIndex: 999999,
        right: 18,
        top: 14,
        opacity: 0,
        pointerEvents: "none",
        color: this.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_COLOR,
        transition: this.themeProps.DEFAULT_TRANSITION,
    };

    @styleRule
    visible = {
        opacity: "1 !important",
        pointerEvents: "all !important",
        cursor: "pointer",
    };
}

@registerStyle(WidgetCloseButtonStyle)
export class WidgetCloseButton extends CloseIcon {
    extraNodeAttributes(attr: NodeAttributes) {
        super.extraNodeAttributes(attr);

        const currentURL = Router.getCurrentPath();
        if (currentURL !== "/" + WidgetRoutes.INDEX_COLLAPSED) {
            attr.addClass(this.styleSheet.visible);
        }
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => collapseIframe());

        this.attachChangeListener(Router.Global, (url: string[], realPage: UIElement) => {
            // To change the color depending on the right page theme
            const theme = realPage?.getTheme(); // TODO bugfix, this is broken, not the real page
            this.updateOptions({theme});
        });
    }
}
